import * as React from "react";
import { forwardRef } from "react";
const SvgFinancial = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ React.createElement("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props
}, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", {
	d: "M14 10.1842C15.1046 10.1842 16 10.9265 16 11.8421M14 10.1842C12.8954 10.1842 12 10.9265 12 11.8421C12 12.7577 12.8954 13.5 14 13.5C15.1046 13.5 16 14.2423 16 15.1579C16 16.0735 15.1046 16.8158 14 16.8158M14 10.1842V9M14 16.8158C12.8954 16.8158 12 16.0735 12 15.1579M14 16.8158V18",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M12 5V7.5C12 8.88071 10.8807 10 9.5 10H7M12 5H19C20.1046 5 21 5.89543 21 7V19C21 20.1046 20.1046 21 19 21H9C7.89543 21 7 20.1046 7 19V10M12 5L10 7L7 10",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M19 5V5C19 3.89543 18.1046 3 17 3L12.4375 3L6 3C4.89543 3 4 3.89543 4 5L4 12.2857L4 14C4 15.1046 4.89543 16 6 16L7 16",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round"
}));
const ForwardRef = forwardRef(SvgFinancial);
export default ForwardRef;
